import dayjs from 'dayjs';
import { DurationUnit } from '@/gql/enums';
import type { Duration } from '@/pages/ProgramManagementPage/ProgramListing/ProgramListing.graphql';

export const createDateOnly = (date: Date, days?: number) => {
    let copyDate = dayjs(date);
    if (days) {
        copyDate = copyDate.add(days, 'day');
    }
    return copyDate.startOf('day').toDate();
};

/**
 * Convert Duration to Date
 */
export const durationToDays = (duration: Duration): number => {
    const baseDate = dayjs();
    let targetDate = baseDate;
    if (duration.unit === DurationUnit.Days) {
        targetDate = targetDate.add(duration.value, 'day');
    } else if (duration.unit === DurationUnit.Weeks) {
        targetDate = targetDate.add(duration.value * 7, 'day');
    } else if (duration.unit === DurationUnit.Months) {
        targetDate = targetDate.add(duration.value, 'month');
    } else if (duration.unit === DurationUnit.Years) {
        targetDate = targetDate.add(duration.value, 'year');
    }
    return targetDate.diff(baseDate, 'day');
};
